import React, { useEffect, useState } from 'react';
import SidebarNav from "../Sidebar/SidebarNav.js";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import customDataService from "../../../services/customDataService.js";
import projectsService from "../../../services/projectsService.js";
import ModalCustomFieldFor from "../CustomFields/ModalCustomFieldFor.js";
import usePageAuthorization from "../../../helpers/usePageAuthorization.js";
import LoadingContent from "../../public/LoadingContent.js";
import DashboardRcj from "../Dashboard/DashboardRcj.js";

const ProjectCustomFields = () => {
    const { projectId } = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [visibleEditButton, setVisibleEditButton] = useState(false);
    const [title, setTitle] = useState("");
    const projectData = location.state;

    const [dataSet, setDataSet] = useState([]);
    const [activeGroupModal, setActiveGroupModal] = useState(null);
    const [saving, setSaving] = useState(false);
    const [hasChanges, setHasChanges] = useState(false);
    const [isRcj, setIsRcj] = useState(false);
    const [rcjData, setRcjData] = useState( {
        group: {},
        values: {}
    });

    const { isAuthorized, isSuperAdmin } = usePageAuthorization({
        allowedRoles: ['Admin', 'Jefatura'],
        setLoading,
    });

    useEffect(() => {

        if (isAuthorized && isSuperAdmin) {
            setVisibleEditButton(true);
        }

        let groupIds = [];
        let rawValues = [];

        setLoading(true);
        projectsService.getProjects().then(data => {
            data.forEach((item) => {
                if(item.id === projectId){
                    try {
                        groupIds = JSON.parse(item.custom_fields_groups) || [];
                    } catch { }

                    try {
                        rawValues = JSON.parse(item.custom_fields_data_values) || [];
                    } catch {}

                    setTitle(item?.project_name);
                }
            });

            setLoading(false);

            customDataService.getCustomDataGroupsForSelectables().then((allGroups) => {
                try {
                    const selected = allGroups.filter(g => groupIds.includes(g.id));
                    const combined = selected.map(group => {
                        const entry = rawValues.find(v => v.groupId === group.id);
                        return { group, values: entry ? entry.values : {} };
                    });
                    setDataSet(combined);
                    setHasChanges(false);
                } catch {}
            });
        });

    }, [projectData, isAuthorized, isSuperAdmin]);

    useEffect(() => {
        if (dataSet.length > 0) {
            dataSet.map(({ group, values }) => {
                if (group.group_name == 'Estadísticas de Juventudes') {
                    setIsRcj(true);
                    setRcjData({
                        group,
                        values
                    });
                }
            })
        }
    }, [dataSet])

    const handleEditGroup = (group) => {
        setActiveGroupModal(group);
    };

    const handleSaveGroupValues = (groupId, newValues) => {
        setDataSet(prev => prev.map(entry =>
            entry.group.id === groupId ? { ...entry, values: newValues } : entry
        ));
        setHasChanges(true);
        setActiveGroupModal(null);
    };

    const handleSaveAll = () => {
        setSaving(true);
        const groups = dataSet.map(entry => entry.group.id);
        const values = dataSet.map(entry => ({ groupId: entry.group.id, values: entry.values }));
        const payload = {
            custom_fields_groups: JSON.stringify(groups),
            custom_fields_data_values: JSON.stringify(values)
        };
        projectsService.setProjects(projectId, payload)
            .then(() => {
                setSaving(false);
                setHasChanges(false);
                navigate(-1);
            })
            .catch(() => setSaving(false));
    };

    return (
        <div className="container-fluid">
            <div className="row vh-100">
                <SidebarNav />
                <div className="p-4 content-container col-md-9 col-lg-10">
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <div className="d-flex align-items-center">
                            <h3 className="mb-0">
                                <i className="bi bi-list-task"></i>&nbsp;
                                {title}
                                <span> &gt; Campos Personalizados</span>
                            </h3>
                        </div>
                    </div>

                    {loading && (
                        <LoadingContent/>
                    )}

                    <div className="row">
                        <div className="col">
                            <div className="btn-group" role="group">
                                <button className="btn btn-secondary mb-3"
                                        onClick={() => navigate(-1)}>
                                    <i className="bi bi-arrow-left"></i> Atrás
                                </button>

                                {visibleEditButton && (
                                    <button
                                        className="btn btn-success mb-3"
                                        disabled={!hasChanges || saving}
                                        onClick={handleSaveAll}
                                    >
                                        {saving ? 'Guardando...' : 'Guardar Cambios'}
                                    </button>
                                )}

                            </div>
                        </div>
                    </div>

                    {isRcj && (
                        <DashboardRcj rcjData={{rcjData}}/>
                    )}

                    {!isRcj && (
                        <div className="row">
                            {dataSet.map(({ group, values }) => (
                                <div className="col-md-4 mb-4" key={group.id}>
                                    <div className="card h-100">
                                        <div className="card-body d-flex flex-column">
                                            <h5 className="card-title text-center mb-3">{group.group_name}</h5>
                                            <div className="flex-grow-1">
                                                {Array.isArray(group.custom_fields) && group.custom_fields.map(field => (
                                                    <div className="form-group mb-3" key={field.id}>
                                                        <label className="form-label">{field.field_name}</label>
                                                        {(() => {
                                                            const val = values[field.id];
                                                            switch (field.field_type) {
                                                                case 'checkbox':
                                                                    return <p>{val ? 'Sí' : 'No'}</p>;
                                                                case 'select_multiple':
                                                                    return <p>{Array.isArray(val) ? val.join(', ') : ''}</p>;
                                                                default:
                                                                    return <p>{val ?? ''}</p>;
                                                            }
                                                        })()}
                                                    </div>
                                                ))}
                                            </div>

                                            {visibleEditButton && (
                                                <button
                                                    className="btn btn-primary mt-auto"
                                                    onClick={() => handleEditGroup(group)}
                                                >
                                                    <i className="bi bi-pencil me-2"></i>
                                                    Editar
                                                </button>
                                            )}

                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}

                    {activeGroupModal && (
                        <ModalCustomFieldFor
                            group={activeGroupModal}
                            values={
                                dataSet.find(e => e.group.id === activeGroupModal.id)?.values || {}
                            }
                            onChange={(data) => handleSaveGroupValues(activeGroupModal.id, data)}
                            onClose={() => setActiveGroupModal(null)}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default ProjectCustomFields;
